import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerTabClick = props => {
  const datalayerTabClickHandler = event => {
    if (containsValidTargetClass(["nav-entry"], event?.target?.classList)) {
      let ariaControls = event.target.getAttribute("aria-controls") || null

      let getTheNumbers = /(\d+)/g
      let getTheTitle = /[^: ]*$/g
      let theNumbers = null
      let theTitle = null
      if (ariaControls) {
        theNumbers = ariaControls.match(getTheNumbers)
        theTitle = ariaControls.match(getTheTitle)
      }
      let tab_title = null
      let tab_number = null
      let total_tabs = null
      if (theTitle) {
        tab_title = theTitle[0]
      }
      if (theNumbers) {
        tab_number = theNumbers[0]
      }
      if (theNumbers) {
        total_tabs = theNumbers[1]
      }

      window.dataLayer.push({
        event: "tab_click",
        tab_title: tab_title,
        tab_number: tab_number, //starting with 1, left to right or top to bottom
        total_tabs: total_tabs,
      })
    }
  }
  // add handler if relevant listener elem exists
  let query = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query = document?.querySelectorAll(".nav-entry").length > 0
  }
  useClickListener(datalayerTabClickHandler, query)
}

export default DatalayerTabClick
